module.exports = {
  Serializer: require('./lib/serializer'),
  Deserializer: require('./lib/deserializer'),
  Error: require('./lib/error'),
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/jsonapi-serializer/index.js
// module id = 124
// module chunks = 0